import postgreApiService from "./apiService";
import { RPC_CONTENT_ENDPOINTS } from "../endpoints";
import { getStoredUsername } from "../../utils/user";
import { isSuccess } from "./utils";

export const getContentList = async () => {
    const p_username = getStoredUsername();
    const response = await postgreApiService.post(RPC_CONTENT_ENDPOINTS.LIST, { p_username });
    const data = response?.data || {};
    const list = data?.Data || data?.data || data?.Contents || data?.contents || data?.Items || data?.items || data;
    return Array.isArray(list) ? list : [];
};

export const getContentById = async (id) => {
    const p_username = getStoredUsername();
    const response = await postgreApiService.post(RPC_CONTENT_ENDPOINTS.GET_BY_ID, {
        p_username,
        p_id: Number(id),
    });
    const data = response?.data || {};
    // Response may be a direct object or wrapped
    return data?.Data || data?.data || data?.Content || data?.content || data;
};

export const createContent = async (payload) => {
    const p_username = getStoredUsername();
    const response = await postgreApiService.post(RPC_CONTENT_ENDPOINTS.CREATE, {
        p_username,
        p_title: payload.title || "",
        p_platform: payload.platform || "",
        p_link: payload.link || "",
        p_file_type: payload.fileType || "",
        p_post_type: payload.postType || "",
        p_caption: payload.caption || "",
        p_accepted_terms: payload.acceptedTerms ?? false,
        p_media_url: payload.mediaUrl || "",
        p_thumbnail_url: payload.thumbnailUrl || null,
        p_cloudflare_id: payload.cloudflareId || "",
    });
    const data = response?.data || {};
    const success = isSuccess(data?.success ?? data?.Success);
    return {
        success,
        contentId: data?.contentId ?? data?.ContentId ?? data?.content_id ?? null,
        message: data?.message || data?.Message || "",
        error: !success ? (data?.message || data?.Message || "Failed to create content.") : undefined,
    };
};

export const updateContent = async (id, payload) => {
    const p_username = getStoredUsername();
    const response = await postgreApiService.post(RPC_CONTENT_ENDPOINTS.UPDATE, {
        p_username,
        p_id: id,
        p_title: payload.title || "",
        p_platform: payload.platform || "",
        p_link: payload.link || "",
        p_file_type: payload.fileType || "",
        p_post_type: payload.postType || "",
        p_caption: payload.caption || "",
        p_media_url: payload.mediaUrl || "",
        p_thumbnail_url: payload.thumbnailUrl || null,
        p_cloudflare_id: payload.cloudflareId || "",
    });
    const data = response?.data || {};
    const success = isSuccess(data?.Success ?? data?.success);
    return {
        success,
        contentId: data?.contentId ?? data?.ContentId ?? data?.content_id ?? null,
        message: data?.Message || data?.message || "",
        error: !success ? (data?.Message || data?.message || "Failed to update content.") : undefined,
    };
};

export const deleteContent = async (id) => {
    const p_username = getStoredUsername();
    const response = await postgreApiService.post(RPC_CONTENT_ENDPOINTS.DELETE, {
        p_username,
        p_id: id,
    });
    const data = response?.data || {};
    return {
        success: isSuccess(data?.Success),
        message: data?.Message || "",
        error: !isSuccess(data?.Success) ? (data?.Message || "Failed to delete content.") : undefined,
    };
};
